import moment from "moment-timezone";
import {
  MAX_AVAILABILITY_PERIODS,
  START_OF_BUSINESS_HOURS,
  END_OF_BUSINESS_HOURS,
} from "./constants";
import {
  CRONOFY_ERROR_TYPE_KEY,
  CRONOFY_ISO_FORMAT,
  CRONOFY_NOTIFICATION_TYPE,
} from "./DateTimePicker/constants";

const setNextWeekday = (date) => {
  const FRIDAY = 5;

  const dayOfWeek = parseInt(date.format("e"), 10);
  const daysToAdd = dayOfWeek === FRIDAY ? 3 : 1;

  date.add(daysToAdd, "days");
};

// Filters out all non-business hours (weekends and early/late hours)
export const queryPeriods = (tz) => {
  const day = moment().tz(tz).minutes(0).seconds(0);

  return [...Array(MAX_AVAILABILITY_PERIODS)].map(() => {
    setNextWeekday(day);

    return {
      start: day.hours(START_OF_BUSINESS_HOURS).format(CRONOFY_ISO_FORMAT),
      end: day.hours(END_OF_BUSINESS_HOURS).format(CRONOFY_ISO_FORMAT),
    };
  });
};

const transformSlotDetails = ({ slot, tzid }) => ({
  start: slot.start,
  end: slot.end,
  participants: slot.participants.map((participant) => participant.sub),
  timeZone: tzid,
});

export const getConfig = ({
  elementToken,
  interviewerIds = [],
  durationInMinutes,
  onDurationMissingError,
  onError,
  onSlotSelected,
  isReadOnly,
  selectedDate,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
  targetId,
}) => ({
  element_token: elementToken,
  target_id: targetId,
  availability_query: {
    participants: [
      {
        required: "all",
        members: interviewerIds.map((id) => ({ sub: id })),
      },
    ],
    required_duration: { minutes: durationInMinutes },
    query_periods: queryPeriods(timezone),
  },
  config: {
    selected_date: selectedDate?.split("T")[0], // Just the date without the timezone
    mode: isReadOnly ? "no_confirm" : "confirm",
  },
  callback: ({ notification }) => {
    // `[required_duration.minutes]` is not a mistake and is literally a single
    // key in the notification body from Cronofy
    const isMissingDuration =
      notification.body &&
      notification.body["required_duration.minutes"]?.at(0)?.key ===
        CRONOFY_ERROR_TYPE_KEY.REQUIRED &&
      !durationInMinutes;

    if (
      notification.type === CRONOFY_NOTIFICATION_TYPE.ERROR &&
      isMissingDuration
    ) {
      onDurationMissingError(notification);
    } else if (notification.type === CRONOFY_NOTIFICATION_TYPE.ERROR) {
      onError(notification);
    }

    if (notification.type === CRONOFY_NOTIFICATION_TYPE.SLOT_SELECTED) {
      onSlotSelected({
        ...transformSlotDetails(notification),
        durationInMinutes,
      });
    }
  },
  styles: {
    prefix: "ha",
  },
  tzid: Intl.DateTimeFormat().resolvedOptions().timeZone,
});
